module Meevo.Plugins.SaleProgram {
    "use strict";

    import ISaleProgram = Meevo.Model.ISaleProgram;

    export class ServicesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<ISaleProgram> {
        model: ISaleProgram;

        private servicesList: any[];
        private discountAmount: number;
        private discountPercent: number;

        private serviceCategories: any[];
        private subCategoryId: string = null;
        private displayName: string = null;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,            
            noun: Meevo.Model.NounEnum,
            private modalService: Meevo.Components.Modal.IModalService,
            securityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, securityKey);

            this.setInitialValues();
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint)
                .then((data: ISaleProgram) => {
                    this.model = data;
                });
        }

        loadServicesList(model: ISaleProgram): void {
            let data = {
                id: model.id,
                businessTypeId: model.businessTypeId,
                startDate: model.startDate,
                endDate: model.endDate,
            };

            this.dataService.customMethodData(`api/saleProgram/${model.id}/service/list`, 'POST', data)
                .then((response: any) => {
                    this.servicesList = response.data;

                    this.generateFilters();
                });
        }

        private generateFilters() {
            this.subCategoryId = null;
            this.displayName = null;

            this.serviceCategories = _.chain(this.servicesList)
                .map(item => ({
                    id: item.subCategoryId,
                    displayName: `${item.category}: ${item.subCategory}`,
                }))
                .sortBy(item => item.displayName)
                .unique(false, (item) => item.id)
                .value();
        }

        setInitialValues(): void {
        }

        preSave(): void {
        }

        sectionModelRetrieved(): void {
            if (!this.model) return;

            this.loadServicesList(this.model);

            switch (this.model.services.discountTypeEnum) {
                case Meevo.Model.DiscountTypeEnum.AmountOff:
                case Meevo.Model.DiscountTypeEnum.SpecialPrice:
                    this.discountAmount = this.model.services.discountAmount;
                    break;
                case Meevo.Model.DiscountTypeEnum.PercentOff:
                    this.discountPercent = this.model.services.discountAmount;
                    break;
            }
        }

        displayItem(item: any): string {
            return `${item.shortcut}: ${item.displayName}`;
        }

        discountAmountChanged() {
            this.model.services.discountAmount = this.discountAmount;
        }

        discountPercentChanged() {
            this.model.services.discountAmount = this.discountPercent;
        }

        filter(item: any): boolean {
            if (this.subCategoryId && item.subCategoryId !== this.subCategoryId) {
                return false;
            }

            if (this.displayName && this.displayName.length > 0) {
                let displayName = item.displayName || '';
                let shortcut = item.shortcut || '';

                if (!(displayName.toLowerCase().indexOf(this.displayName.toLowerCase()) > -1 ||
                    shortcut.toLowerCase().indexOf(this.displayName.toLowerCase()) > -1)) {
                    return false;
                }
            }

            return true;
        }


        filterModal() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/saleProgram/modal/services.filter.template.html",
                controller: "meevo.plugins.saleProgram.ServicesFilterController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    context: this,
                }
            }

            this.modalService.showCustom(options);
        }
    }
}